import type { GameConfig } from '../../../config/gameConfig';

export function getFoodPerPersonPerTick(config: GameConfig): number {
    const interval = Math.max(1, config.population.hunger.hungerInterval);
    const hungerStep = Math.max(0, config.population.hunger.hungerStep);
    const foodStep = Math.max(0.0001, config.population.hunger.foodStep);
    return hungerStep / interval / foodStep;
}

export function getFoodPerPersonPerHour(config: GameConfig): number {
    return getFoodPerPersonPerTick(config) * config.time.ticksPerHour;
}
